import podcastImg from '@epi-assets/images/Edenred-EMP-banner-Etumatkalla-podcast.jpg';
import rewardingImg from '@epi-assets/images/Edenred-EMP-banner-Rewarding-guide.jpg';
import bestLunchImg from '@epi-assets/images/Edenred-EMP-banner-best_lunch_2025.png';
import lunchImg from '@epi-assets/images/Edenred-EMP-banner-lunch.jpg';
import paymentImg from '@epi-assets/images/Edenred-EMP-banner-payment.jpg';

interface BannerContent {
  locale: 'en' | 'fi';
  header: string;
  imageAlt: string;
  imageSrc: string;
  link: string;
  linkKind: 'Relative';
  linkText: string;
  text: string;
  linkTwo?: string;
  linkTextTwo?: string;
  sameTab?: boolean;
  sameTabTwo?: boolean;
}

interface Banner {
  content: BannerContent;
  id: number;
  name: string;
  priority: number;
  templateName: 'Banner';
  startDate?: Date;
  endDate?: Date;
}

export const homeBanner = (
  paymentLimitsImg: string,
  delicardImg: string,
  taxationImg: string
): Banner[] => [
  {
    content: {
      locale: 'en',
      header: 'Lunch benefit in 2026',
      imageAlt: 'A person eating lunch',
      imageSrc: lunchImg,
      link: '/en/manage-benefits',
      sameTab: true,
      linkKind: 'Relative',
      linkText: 'Lounari settings',
      text: 'The new lunch benefit values (8.80€ - 14.00€) are valid and can be updated to Lounari settings from 1.1.2026. If the lunch benefit is loaded with the Maximum benefit value option, it will update automatically without any action required.'
    },
    id: 15,
    name: 'Lunch values',
    priority: 1,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-02-01')
  },
  {
    content: {
      locale: 'fi',
      header: 'Lounasetu vuonna 2026',
      imageAlt: 'A person eating lunch',
      imageSrc: lunchImg,
      link: '/manage-benefits',
      sameTab: true,
      linkKind: 'Relative',
      linkText: 'Lounarin asetukset',
      text: 'Lounasedun uudet arvot (8,80 € - 14,00 €) ovat voimassa ja päivitettävissä Lounarin asetuksiin 1.1.2026 alkaen. Mikäli lounasetu on ladattu Edun maksimiarvo -valinnalla, se päivittyy automaattisesti ilman toimenpiteitä. '
    },
    id: 16,
    name: 'Lunch values',
    priority: 1,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-02-01')
  },
  {
    content: {
      locale: 'fi',
      header: 'Suomen paras lounas 2025',
      imageAlt: 'Best lunch logo',
      imageSrc: bestLunchImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2025&utm_content=banner',
      linkKind: 'Relative',
      linkText: 'Äänestä nyt',
      text: 'Edenred etsii jälleen Suomen parasta lounasta. Kannusta henkilöstöäsi äänestämään lempilounastaan nyt! Äänestäneiden kesken arvotaan lounasrahaa sekä lahjakortteja mm. Kotipizzaan ja Espresso Houseen.'
    },
    id: 2,
    name: 'Best Lunch 2025',
    priority: 4,
    templateName: 'Banner',
    startDate: new Date('2025-09-01'),
    endDate: new Date('2025-09-22')
  },
  {
    content: {
      locale: 'en',
      header: 'Employee benefit payment limits',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/en/blog/employee-benefit-payment-limits',
      linkKind: 'Relative',
      linkText: 'Check the payment limits',
      text: "What were the tax-free payment limits this year? You'll find them by clicking the link!"
    },
    id: 3,
    name: 'Payment Limits',
    priority: 2,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Työsuhde-etujen ajankohtaiset maksurajat',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/fi/blog/tyosuhde-etujen-maksurajat',
      linkKind: 'Relative',
      linkText: 'Tarkista maksurajat',
      text: 'Mitä olivatkaan verovapaat maksurajat tänä vuonna? Löydät ne linkin takaa!'
    },
    id: 4,
    name: 'Payment Limits',
    priority: 2,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Paper vouchers valid until 31.12.2026',
      imageAlt: 'A person eating lunch',
      imageSrc: paymentImg,
      link: 'https://edenred.fi/en/vouchers-to-digital-benefits',
      linkTwo: 'https://edenred.fi/en/vouchers-to-digital-benefits#contact-us',
      linkKind: 'Relative',
      linkText: 'Read more',
      linkTextTwo: 'Contact us',
      text: 'The sale of Lunch and Virike vouchers will end on 31.5.2026. All vouchers order payments must be completed by 12.6.2026 to accept the orders. Payments received after this date will be refunded. The vouchers will remain as a payment method until 31.12.2026. Be sure to inform your employees accordingly.'
    },
    id: 17,
    name: 'Vouchers',
    priority: 3,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-12-31')
  },
  {
    content: {
      locale: 'fi',
      header: 'Paperiset setelit voimassa 31.12.2026 asti',
      imageAlt: 'A person eating lunch',
      imageSrc: paymentImg,
      link: 'https://edenred.fi/fi/seteleista-digitaalisiin-tyosuhde-etuihin',
      linkTwo:
        'https://edenred.fi/fi/seteleista-digitaalisiin-tyosuhde-etuihin#ota-yhteytta',
      linkKind: 'Relative',
      linkText: 'Lue lisää',
      linkTextTwo: 'Ota yhteyttä',
      text: 'Lounas- ja Virikeseteleiden myynti päättyy 31.5.2026. Kaikkien setelitilausten maksujen on oltava suoritettuna viimeistään 12.6.2026, jotta tilaukset voidaan hyväksyä. Tämän jälkeen vastaanotetut maksut palautetaan. Setelit toimivat maksutapana 31.12.2026 asti. Muista tiedottaa asiasta myös työntekijöillesi.'
    },
    id: 18,
    name: 'Vouchers',
    priority: 3,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-12-31')
  },
  {
    content: {
      locale: 'en',
      header: "Finland's Best Lunch 2025",
      imageAlt: 'Best lunch logo',
      imageSrc: bestLunchImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2025&utm_content=banner',
      linkKind: 'Relative',
      linkText: 'Vote now',
      text: 'Edenred is looking for the best lunch in Finland. Encourage your employees to vote for their favorite lunch spot now! Voting is easy, and among voters we will raffle lunch money, gift cards to Kotipizza and Espresso House and more!'
    },
    id: 1,
    name: 'Payment Limits',
    priority: 4,
    templateName: 'Banner',
    startDate: new Date('2025-09-01'),
    endDate: new Date('2025-09-22')
  },
  {
    content: {
      locale: 'en',
      header: "Edenred's podcast: Etumatkalla",
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Explore (in Finnish)',
      text: `Are you looking for a Finnish podcast on HR topics that provides practical tips for people interested in workplace well-being? Edenred's Etumatkalla podcast is made for a better working life!`
    },
    id: 5,
    name: 'Podcast',
    priority: 6,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Edenredin Etumatkalla-podcast',
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Tutustu ja kuuntele',
      text: 'Oletko etsinyt suomenkielistä HR-aiheista podcastia, jossa annetaan käytännönläheisiä vinkkejä työhyvinvoinnista kiinnostuneille? Edenredin Etumatkalla-podcast on tehty parempaa työelämää varten!'
    },
    id: 6,
    name: 'Podcast',
    priority: 6,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Want to learn more about benefit taxation? ',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/en/download-tax-guide?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download tax guide',
      text: 'Clarify employee benefit taxation by downloading our comprehensive and highly popular tax guide.'
    },
    id: 7,
    name: 'Tax guide',
    priority: 7,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Haluatko oppia lisää etujen verotuksesta?',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/fi/lataa-verotusopas?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa verotusopas',
      text: 'Selvennä työsuhde-etujen verotuksen kiemuroita lataamalla kattava ja suuren  suosion  saanut vero-oppaamme.'
    },
    id: 8,
    name: 'Tax guide',
    priority: 7,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Are you looking for tips on tax-free rewarding?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/en/delicard-abcs-of-rewarding?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download rewarding guide',
      text: 'Rewarding employees fosters commitment to the workplace, increases motivation, and improves the employee experience. Do you know how to reward employees tax-free in various situations? Download our guide to find out!'
    },
    id: 9,
    name: 'Rewarding guide',
    priority: 8,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Kaipaatko vinkkejä verovapaaseen palkitsemiseen?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/fi/delicard-palkitsemisen-abc?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa palkitsemisen opas',
      text: 'Työntekijöiden palkitseminen sitouttaa työpaikkaan, lisää motivaatiota, ja parantaa työntekijäkokemusta. Tiedätkö, miten voit palkita henkilöstöä erilaisissa tilanteissa verovapaasti? Lataa oppaamme niin se selviää!'
    },
    id: 10,
    name: 'Rewarding guide',
    priority: 8,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Tax-free recognition on special occasions',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/en/buy-gift-cards?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/en/request-offer?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Order gift cards',
      linkTextTwo: 'Request an offer',
      text: 'Christmas gifts, retirement, anniversaries and birthdays, summer gifts... Delicard® gift cards offer a tax-free option for expressing gratitude and congratulations for every celebration!'
    },
    id: 11,
    name: 'Delicard®',
    priority: 9,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Verovapaata muistamista merkkipäivinä',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/pyyda-tarjous?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Osta lahjakortteja',
      linkTextTwo: 'Kysy tarjous',
      text: 'Joululahja, eläkkeelle siirtyminen, merkki- ja syntymäpäivät, kesälahja... Delicard®-lahjakortit tarjoavat verovapaan vaihtoehdon kiitoksen osoittamiseen ja onnitteluun jokaisessa juhlan aiheessa!'
    },
    id: 12,
    name: 'Delicard®',
    priority: 9,
    templateName: 'Banner'
  }
];
